export default {
  mainApi: 'https://admin-api.guavapass.cn',
  authApi: 'https://admin-api.guavapass.cn',
  assetUrl: 'https://assets-cdn.guavapass.cn',
  guavapassUrl: 'https://guavapass.cn',
  tencentMapKey: 'MRABZ-J5VKZ-GUWXU-ZIA5Z-M4EM5-JWFQN',
}
